// extracted by mini-css-extract-plugin
export default {"background":"App_background__FLGfH"};